import { render, staticRenderFns } from "./SelectedPackagesPanel.vue?vue&type=template&id=1ba7c7b4&"
import script from "./SelectedPackagesPanel.vue?vue&type=script&lang=js&"
export * from "./SelectedPackagesPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports